export var COLUMN_MIN_WIDTH = 48;
export var TABLE_MAX_WIDTH = 1800;